var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Ethiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f47af",
    d: "M35,23.898c0,6.078-4.926,11-11,11s-11-4.922-11-11c0-6.074,4.926-11,11-11S35,17.824,35,23.898z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M26.723,19.746l2.234-3.074l0.809,0.59l-2.234,3.07L26.723,19.746z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M28.832,26.266l0.309-0.949l3.52,1.145l-0.309,0.949L28.832,26.266z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M23.5,29h1v4h-1V29z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M15.32,26.391l3.52-1.141l0.309,0.949l-3.52,1.145L15.32,26.391z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M18.254,17.188l0.809-0.59l2.234,3.074l-0.809,0.59L18.254,17.188z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M25.199,21h-1.301l-0.297,1h5.098l1.402-1h-3.801L24,14.102l-0.5,1.598L25.199,21z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M21.398,22L21,23.301l0.898,0.598l1.602-5L23,17.301L21.699,21H14.5l1.301,1H21.398z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M22.301,26.699l0.898-0.598L21.5,24.898L18.898,23h-1.699l3.102,2.301l-2.199,6.898l1.398-1 l1.699-5.301L22.301,26.699z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M24.898,27.301l1-0.801l-0.297-1l-4.203,3.102l-0.5,1.598L24,27.898l5.898,4.301l-0.5-1.598 L24.898,27.301z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M27.5,28l1.301,1l-1.199-3.699L33.5,21h-1.699l-4.5,3.301L26.898,23h-1L27.5,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ethiopia);
export default __webpack_public_path__ + "static/media/icons8-ethiopia.def1dbbf5d0c70bc327d079eb970d6f2.svg";
export { ForwardRef as ReactComponent };